module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login"
    }
  }, [_c('ul', {
    staticClass: "login-type list-unstyled"
  }, [_c('li', {
    on: {
      "click": function($event) {
        _vm.isEmailLogin = true
      }
    }
  }, [_c('a', {
    class: {
      'active': _vm.isEmailLogin
    },
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v(_vm._s(_vm.$t('emailLogin')))])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.isEmailLogin = false
      }
    }
  }, [_c('a', {
    class: {
      'active': !_vm.isEmailLogin
    },
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v(_vm._s(_vm.$t('phoneLogin')))])])]), _vm._v(" "), _c('email-login', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEmailLogin),
      expression: "isEmailLogin"
    }],
    staticClass: "email-phone-login"
  }), _vm._v(" "), _c('phone-login', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEmailLogin),
      expression: "!isEmailLogin"
    }],
    staticClass: "email-phone-login"
  }), _vm._v(" "), _c('third-part-login', {
    staticClass: "oauth-login"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3e960532!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/login/Login.vue
// module id = 1303
// module chunks = 1